export default __webpack_public_path__ + "static/media/breuls.c7e46428.png";